export interface DutyHolderDetail {
    id: number;
    project_id: number;
    folder_id: number;
    type: 'Client' | 'P. Designer' | 'P. Contractor';
    client_name: string | null;
    address: string | null;
    email: string | null;
    telephone: string | null;
    work_complete_date: string | null;
    declare_that: string | null;
    principal_designer: string | null;
    name: string | null;
    appointment_date: string | null;
    sign_report: 1 | 0;
    sign: string | null;
    sign_date: string | null;
    sign_report_by: number | null;
}

// Single object mapping
export const mapDutyHolderDetail = (data: any): DutyHolderDetail => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const response: DutyHolderDetail = {
        id: data?.id,
        project_id: data?.project_id,
        folder_id: data?.folder_id,
        type: data?.type,
        client_name: data?.client_name || null,
        address: data?.address || null,
        email: data?.email || null,
        telephone: data?.telephone || null,
        work_complete_date: data?.work_complete_date || null,
        declare_that: data?.declare_that || null,
        principal_designer: data?.principal_designer || null,
        name: data?.name || null,
        appointment_date: data?.appointment_date || null,
        sign_report: data?.sign_report,
        sign: data?.sign || null,
        sign_date: data?.sign_date || null,
        sign_report_by: data?.sign_report_by || null,
    };

    return response;
};

// List mapping
export const mapDutyHolderDetails = (data: any[]): DutyHolderDetail[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapDutyHolderDetail);
};
